import {
  AUTHENTICATE_USER,
  AUTHENTICATE_USER_SUCCEEDED,
  AUTHENTICATE_USER_FAILED,
  FETCH_SSO_URL,
  FETCHING_SSO_URL_SUCCEEDED,
  FETCHING_SSO_URL_FAILED,
  SSO_AUTHENTICATION_SUCCESS,
  INVALIDATE_SSO,
  GENERATE_TOKEN_FOR_SSO_USER,
  GENERATE_TOKEN_FOR_SSO_USER_SUCCEEDED,
  GENERATE_TOKEN_FOR_SSO_USER_FAILED,
  CAPABILITY_ACTIVATION
} from "constants/actionTypes";

import { createAction } from "redux-actions";
import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import buildUrl from "build-url";
import AuthService from "services/auth.service";

const apiUrl = process.env.REACT_APP_API_URL;
const usersApi = process.env.REACT_APP_USERS_API_URL;

const AUTHORIZE_URL = `${usersApi}/users/3.0/oauth/token`;
const SSO_URL = `${apiUrl}/api/2.0/users/sso/initiate`;
const USERS_URL = `${apiUrl}/api/2.0/users`;
const CAPABILITY_URL = `${apiUrl}/api/2.0/capability-activation`;

//Fetch Seek Answer
export const authenticateUser = createAction(
  AUTHENTICATE_USER,
  (username, password, callback) => {
    return { username, password, callback };
  }
);

const authenticateUserSucceeded = createAction(
  AUTHENTICATE_USER_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const authenticateUserFailed = createAction(
  AUTHENTICATE_USER_FAILED,
  (error) => {
    return { error };
  }
);

function* authenticateUserSaga(action) {
  const { username, password, callback } = action.payload;

  const authenticateUserAPI = () => {
    

  const data = {
    username: username,
    password: password,
  };

    const authorization = btoa(
      "paperflite-chrome-extension:bf8bbed1-9359-4a13-bdd6-946c411de1e7"
    );

    return axios({
      method: "POST",
      url: AUTHORIZE_URL,
       data
    }).then((response) => response.data);
  };

  try {
    const response = yield call(authenticateUserAPI);
    yield put(authenticateUserSucceeded(response));
    AuthService.saveToken(response.access_token, response.refresh_token);

    //Trigger capability activation automatically after login succeeds
    yield put(capabilityActivation("CHROME_EXTENSION"));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(authenticateUserFailed(error));
  }
}

/**
 * Fetch SSO URL for email
 *
 */
export const fetchSSOUrlFromEmail = createAction(FETCH_SSO_URL, (email) => {
  return { email };
});

const fetchingSSOUrlFromEmailSuccedded = createAction(
  FETCHING_SSO_URL_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const fetchingSSOUrlFromEmailFailed = createAction(
  FETCHING_SSO_URL_FAILED,
  (error) => {
    return { error };
  }
);

function* fetchSSOUrlFromEmailSaga(action) {
  const fetchSSOUrlFromEmailAPI = () => {
    const { email } = action.payload;

    let url = buildUrl(SSO_URL, {
      queryParams: {
        email: email,
      },
    });

    return axios({
      method: "GET",
      url: url,
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(fetchSSOUrlFromEmailAPI);
    yield put(fetchingSSOUrlFromEmailSuccedded(response));
  } catch (error) {
    yield put(fetchingSSOUrlFromEmailFailed(error));
  }
}

/**
 * Generate Token for SSO User
 *
 */
export const generateTokenForSSOUser = createAction(
  GENERATE_TOKEN_FOR_SSO_USER,
  (token) => {
    return { token };
  }
);

const generateTokenForSSOUserSucceeded = createAction(
  GENERATE_TOKEN_FOR_SSO_USER_SUCCEEDED,
  (response) => {
    return { response };
  }
);

const generateTokenForSSOUserFailed = createAction(
  GENERATE_TOKEN_FOR_SSO_USER_FAILED,
  (error) => {
    return { error };
  }
);

function* generateTokenForSSOUserSaga() {
  const generateTokenForSSOUserAPI = (token) => {

    const authorization = btoa(
      "paperflite-chrome-extension:bf8bbed1-9359-4a13-bdd6-946c411de1e7"
    );

    const data = {
      refresh_token: token
    }

    return axios({
      method: "POST",
      url: `${AUTHORIZE_URL}/refresh`,
      data
    }).then((response) => {
      return response.data;
    });
  };
  try {
    const response = yield call(generateTokenForSSOUserAPI);
    const message = { type: "request", data: "Message from React component" };
    window.postMessage(message, "*");
    yield put(generateTokenForSSOUserSucceeded(response));
    AuthService.saveToken(response.accessToken, response.refreshToken);
    window.parent.postMessage(
      {
        type: "PAPERFLITE_AUTHENTICATION",
        refresh_token: AuthService.getRefreshToken(),
        access_token: AuthService.getAccessToken(),
      },
      "*"
    );
  } catch (error) {
    yield put(generateTokenForSSOUserFailed(error));
  }
}

export const invalidateSSO = createAction(INVALIDATE_SSO);
export const authenticateSSO = createAction(SSO_AUTHENTICATION_SUCCESS);

export const capabilityActivation = createAction(
  CAPABILITY_ACTIVATION,
  (capabilityType) => {
    return { capabilityType };
  }
);

function* capabilityActivationSaga(action) {
  const { capabilityType } = action.payload;

  const capabilityActivationAPI = () => {
    return axios({
      method: "POST",
      url: `${CAPABILITY_URL}/${capabilityType}`,
    }).then((response) => response.data);
  };

  try {
    yield call(capabilityActivationAPI);
  } catch (error) {
    console.error("Capability activation failed:", error);
  }
}


export default function* loginSaga() {
  yield takeEvery(AUTHENTICATE_USER, authenticateUserSaga);
  yield takeEvery(FETCH_SSO_URL, fetchSSOUrlFromEmailSaga);
  yield takeEvery(GENERATE_TOKEN_FOR_SSO_USER, generateTokenForSSOUserSaga);
  yield takeEvery(CAPABILITY_ACTIVATION, capabilityActivationSaga);
}
